export default "__VITE_ASSET__ZNqRFL_j__"